<template>
  <div class="qaqc-pagination-container qaqc-overview-pagination" v-if="totalItems > 0">
    <div class="qaqc-pagination-left">
      <v-select
        :model-value="itemsPerPage"
        @update:model-value="$emit('update:itemsPerPage', $event)"
        :items="[10, 20, 50, 100]"
        label="Items per page"
        variant="outlined"
        density="compact"
        class="items-per-page-select"
      ></v-select>
    </div>
    <div class="qaqc-pagination-center">
      <span class="qaqc-pagination-info">
        {{ startIndex + 1 }}-{{ endIndex }} of {{ totalItems }} {{ itemLabel }}
      </span>
    </div>
    <div class="qaqc-pagination-right">
      <v-btn
        icon="mdi-chevron-left"
        variant="text"
        :disabled="currentPage === 1"
        @click="$emit('update:currentPage', currentPage - 1)"
        class="qaqc-pagination-btn"
      ></v-btn>
      <v-btn
        icon="mdi-chevron-right"
        variant="text"
        :disabled="currentPage >= totalPages"
        @click="$emit('update:currentPage', currentPage + 1)"
        class="qaqc-pagination-btn"
      ></v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "QAQCPagination",
  props: {
    totalItems: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
    itemLabel: { type: String, default: "Samples" },
  },
  emits: ["update:currentPage", "update:itemsPerPage"],
  computed: {
    totalPages() {
      if (this.itemsPerPage <= 0) return 1;
      return Math.ceil(this.totalItems / this.itemsPerPage) || 1;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalItems);
    },
  },
};
</script>
